import { useLanguage } from "@/contexts/LanguageContext";
import { useLocaleNavigate } from "@/hooks/useLocaleNavigate";
import { Button } from "@/components/ui/button";
import { ArrowRight, Home, Briefcase, Building2, Check } from "lucide-react";

const ProductFeatures = () => {
  const { t, language } = useLanguage();
  const navigate = useLocaleNavigate();

  const columns = [
    {
      icon: Home,
      title: t.productFeatures.buyers.title,
      features: t.productFeatures.buyers.features,
      cta: t.productFeatures.buyers.cta,
      onClick: () => navigate("/auth"),
      variant: "default" as const,
    },
    {
      icon: Briefcase,
      title: t.productFeatures.agents.title,
      features: t.productFeatures.agents.features,
      cta: t.productFeatures.agents.cta,
      onClick: () => window.open(language === 'ru' ? 'https://tally.so/r/jaMBRE' : 'https://tally.so/r/zxz1Jg', '_blank'),
      variant: "default" as const,
      highlighted: true,
    },
    {
      icon: Building2,
      title: t.productFeatures.enterprise.title,
      features: t.productFeatures.enterprise.features,
      cta: t.productFeatures.enterprise.cta,
      onClick: () => navigate("/contact"),
      variant: "outline" as const,
    },
  ];

  return (
    <section className="py-16 lg:py-20 bg-[hsl(210,20%,98%)]">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-2">
            {t.productFeatures.title}
          </h2>
          <p className="text-muted-foreground max-w-xl mx-auto">
            {t.productFeatures.subtitle}
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {columns.map((col, i) => (
            <div
              key={i}
              className={`rounded-2xl border p-6 flex flex-col ${
                col.highlighted
                  ? "border-primary bg-background shadow-lg ring-1 ring-primary/20"
                  : "border-border bg-background"
              }`}
            >
              <div className="flex items-center gap-3 mb-5">
                <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center">
                  <col.icon className="h-5 w-5 text-primary" />
                </div>
                <h3 className="text-lg font-semibold text-foreground">{col.title}</h3>
              </div>

              <ul className="space-y-3 mb-6 flex-1">
                {col.features.map((f: string, j: number) => (
                  <li key={j} className="flex items-start gap-2.5 text-sm text-muted-foreground">
                    <Check className="h-4 w-4 text-primary mt-0.5 shrink-0" />
                    {f}
                  </li>
                ))}
              </ul>

              <Button
                variant={col.variant}
                className="w-full rounded-full gap-1.5"
                onClick={col.onClick}
              >
                {col.cta}
                <ArrowRight className="h-4 w-4" />
              </Button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductFeatures;
